var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 22,
    viewBox: "0 0 55 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_827_1448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1923 18.9679H19.8721L22.5722 3.05149H26.8928L24.1923 18.9679ZM16.2377 3.05149L12.1191 13.9989L11.6317 11.6415L11.6321 11.6423L10.1785 4.48458C10.1785 4.48458 10.0027 3.05149 8.1291 3.05149H1.32013L1.24023 3.32099C1.24023 3.32099 3.32243 3.73653 5.75928 5.14024L9.51265 18.9683H14.0139L20.8873 3.05149H16.2377ZM50.2182 18.9679H54.1851L50.7265 3.05107H47.2536C45.6499 3.05107 45.2593 4.23722 45.2593 4.23722L38.8161 18.9679H43.3196L44.2202 16.6036H49.7122L50.2182 18.9679ZM45.4644 13.3377L47.7343 7.3814L49.0114 13.3377H45.4644ZM39.1539 6.87901L39.7704 3.46107C39.7704 3.46107 37.868 2.76709 35.8848 2.76709C33.7409 2.76709 28.6497 3.66585 28.6497 8.03621C28.6497 12.1481 34.6251 12.1992 34.6251 14.3591C34.6251 16.5189 29.2653 16.1319 27.4965 14.7699L26.8542 18.3437C26.8542 18.3437 28.7833 19.2425 31.7306 19.2425C34.6788 19.2425 39.1264 17.7783 39.1264 13.7932C39.1264 9.65492 33.0973 9.26962 33.0973 7.47039C33.0977 5.67073 37.3052 5.90191 39.1539 6.87901Z",
    fill: "#2566AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6321 11.6416L10.1785 4.48387C10.1785 4.48387 10.0027 3.05078 8.1291 3.05078H1.32013L1.24023 3.32028C1.24023 3.32028 4.51289 3.97083 7.65194 6.40827C10.6534 8.73799 11.6321 11.6416 11.6321 11.6416Z",
    fill: "#E6A540"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_827_1448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.9,
    height: 22,
    fill: "white",
    transform: "translate(0.845703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa1);
export default __webpack_public_path__ + "static/media/visa1.0aad99113cf32fe51bfff5868a118b33.svg";
export { ForwardRef as ReactComponent };